import React from "react";
import { cn } from "../../utils/cn";
import { Badge } from "./Badge";
interface SectionHeaderProps extends React.HTMLAttributes<HTMLDivElement> {
  badge?: string;
  title: React.ReactNode;
  subtitle?: React.ReactNode;
  align?: "left" | "center";
  theme?: "light" | "dark";
}
export function SectionHeader({
  badge,
  title,
  subtitle,
  align = "center",
  theme = "light",
  className,
  ...props
}: SectionHeaderProps) {
  return <div className={cn("flex flex-col gap-4", {
    "items-center text-center": align === "center",
    "items-start text-left": align === "left"
  }, className)} {...props} data-id="element-290" data-mp="2v70vdqauf18j">
      {badge && <Badge theme={theme} data-id="element-291" data-mp="2l7idrgienrjn">{badge}</Badge>}
      <h2 className={cn("text-[30px] md:text-[42px] lg:text-[54px] font-[900] tracking-[-1px] leading-[1.05]", theme === "dark" ? "text-white" : "text-[#07152D]")} data-id="element-292" data-mp="2lao22tj7mpeb">
        {title}
      </h2>
      {subtitle && <p className={cn("text-[15px] md:text-[17px] max-w-3xl leading-[1.4]", theme === "dark" ? "text-white/95" : "text-gray-600")} data-id="element-293" data-mp="1es80ebmeiaiz">
          {subtitle}
        </p>}
    </div>;
}